import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-faed435a")
const _hoisted_1 = { class: "big-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "big-card__content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "big-card__title" }, " Принимать гостей "),
  /*#__PURE__*/_createElementVNode("div", { class: "big-card__subtitle" }, " Открывайте новые возможности и получайте доход, сдавая жилье. ")
], -1)
const _hoisted_3 = { class: "big-card__actions" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Подробнее ")
_popScopeId()

import BaseButton from "@/components/BaseButton.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

	
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(BaseButton, null, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      })
    ])
  ]))
}
}

})